export default __webpack_public_path__ + "static/media/Icons_Tick_Blue icon.ab3221ea.svg";